var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgVendorIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_466",
    "data-name": "Group 466",
    transform: "translate(0 -0.226)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_327",
    "data-name": "Rectangle 327",
    width: 27,
    height: 27,
    transform: "translate(0 0.226)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "vendor",
    transform: "translate(2.644 2.644)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4033",
    "data-name": "Path 4033",
    d: "M227.007,295.8v2.168h2.5V295.8a4,4,0,0,1-2.5,0Z",
    transform: "translate(-217.207 -283.027)",
    fill: "#a4a4a4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4034",
    "data-name": "Path 4034",
    d: "M143.58,258.21a2.981,2.981,0,0,0-1.572,2.625V262h2.374v-2.888A4.023,4.023,0,0,1,143.58,258.21Z",
    transform: "translate(-135.877 -247.063)",
    fill: "#a4a4a4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4035",
    "data-name": "Path 4035",
    d: "M317.382,260.836a2.981,2.981,0,0,0-1.572-2.625,4.025,4.025,0,0,1-.8.9V262h2.374Z",
    transform: "translate(-301.409 -247.064)",
    fill: "#a4a4a4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4036",
    "data-name": "Path 4036",
    d: "M130.7,466.015h-9.5a1.952,1.952,0,0,1-1.184,1.184v.8H131.88v-.8A1.952,1.952,0,0,1,130.7,466.015Z",
    transform: "translate(-114.827 -445.897)",
    fill: "#a4a4a4"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1",
    "data-name": "Ellipse 1",
    cx: 2.696,
    cy: 2.696,
    r: 2.696,
    transform: "translate(8.356 6.284)",
    fill: "#a4a4a4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4037",
    "data-name": "Path 4037",
    d: "M21.457,376.01H.648a.647.647,0,0,0-.172,1.271v3.952a.648.648,0,0,0,.648.648H3.886v-1.338a.648.648,0,0,1,.648-.648.648.648,0,0,0,.648-.648.648.648,0,0,1,.648-.648H16.405a.648.648,0,0,1,.648.648.648.648,0,0,0,.648.648.648.648,0,0,1,.648.648v1.338h2.763a.648.648,0,0,0,.648-.648v-4a.647.647,0,0,0-.3-1.22Z",
    transform: "translate(0 -359.778)",
    fill: "#a4a4a4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4038",
    "data-name": "Path 4038",
    d: "M451.007,142.485v8.786h1.3v-8.786a3.235,3.235,0,0,1-1.3,0Z",
    transform: "translate(-431.537 -136.334)",
    fill: "#a4a4a4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4039",
    "data-name": "Path 4039",
    d: "M2.949,4.93a1.935,1.935,0,0,0,1.3-.5,1.938,1.938,0,0,0,2.59,0,1.938,1.938,0,0,0,2.59,0,1.938,1.938,0,0,0,2.59,0,1.938,1.938,0,0,0,2.59,0,1.938,1.938,0,0,0,2.59,0,1.938,1.938,0,0,0,2.59,0,1.941,1.941,0,0,0,3.238-1.446V.657a.648.648,0,0,0-.648-.648H1.654a.648.648,0,0,0-.648.648V2.988A1.945,1.945,0,0,0,2.949,4.93Z",
    transform: "translate(-0.963 -0.009)",
    fill: "#a4a4a4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4040",
    "data-name": "Path 4040",
    d: "M31.007,142.486v8.786h1.3v-8.786a3.234,3.234,0,0,1-1.3,0Z",
    transform: "translate(-29.668 -136.334)",
    fill: "#a4a4a4"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVendorIcon);
export default __webpack_public_path__ + "static/media/vendor-icon.29f1d988fea0e81a189f11607296674c.svg";
export { ForwardRef as ReactComponent };